<div [formGroup]="form" class="employee-form-sections">
  <div class="form-control">
    <label class="text-neutral-900" for="name">Nombre y apellido</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="fullName" id="name" placeholder="Por ejemplo: Alfonso Álvarez Fondón" type="text">
    </div>
  </div>

  @if (showRoleField) {
    <div class="form-control">
      <label class="text-neutral-900" for="position">Cargo</label>
      @if (isLoadingOptions) {
        <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
      } @else {
        <core-select
          [options]="roleOptions"
          formControlName="position"
          placeholder="Cargo asociado al usuario"/>
      }
    </div>
  }

  <div class="employee-inline-row">
    <div class="form-control employee-inline-item">
      <label class="text-neutral-900" for="group">Grupo de trabajo</label>
      @if (isLoadingOptions) {
        <div class="h-11 skeleton skeleton-rect rounded-xl"></div>
      } @else {
        <core-select
          [options]="groupOptions"
          formControlName="groupId"
          placeholder="Selecciona un grupo"/>
      }
    </div>

    <div class="form-control employee-inline-item employee-inline-item-compact employee-responsible-control">
      <label class="text-neutral-900" for="responsible">Responsable</label>

      <div class="employee-responsible-options">
        <label class="flex flex-row items-center gap-1">
          <input [value]="true" formControlName="isGroupManager" name="isGroupManager" style="width: 1.5rem" type="radio">
          <span>Si</span>
        </label>
        <label class="flex flex-row items-center gap-1">
          <input [value]="false" formControlName="isGroupManager" name="isGroupManager" style="width: 1.5rem" type="radio">
          <span>No</span>
        </label>
      </div>
    </div>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="email">Email</label>
    <div class="input-icon">
      <input autocomplete="off" formControlName="email" id="email" placeholder="Por ejemplo: AlfonsoAA@nutrexpa.es" type="email">
    </div>
  </div>

  <div class="employee-inline-row employee-inline-row-center">
    <div class="form-control employee-inline-item">
      <label class="text-neutral-900" for="hiredAt">Fecha de alta</label>
      <div class="input-icon">
        <input autocomplete="off" formControlName="hiredAt" id="hiredAt" type="date">
      </div>
    </div>

    <div class="form-control employee-inline-item employee-inline-item-compact mt-auto">
      <div class="flex flex-col gap-1 lg:justify-center">
        <input #contractInput (change)="handleContractSelected($event)" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" class="hidden" type="file">
        <button (click)="openContractPicker()" [disabled]="isSubmitting || isLoadingOptions" class="btn btn-primary-text employee-contract-button" type="button">
          <img alt="Adjuntar contrato" class="filter-primary-600 h-4" src="/assets/icons/feather/upload.svg">
          <span>Adjuntar contrato</span>
        </button>
        @if (contractFileName) {
          <span [title]="contractFileName" class="cd-text-b5 text-neutral-600 truncate">{{ contractFileName }}</span>
        }
      </div>
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="activityKey">¿Realiza una actividad clave para la empresa?</label>

    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="activityKey" id="activityKey" name="activityKey" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="activityKey" name="activityKey" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="activityKey" name="activityKey" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="sensitiveData">¿Tiene acceso a datos sensibles?</label>

    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="sensitiveData" id="sensitiveData" name="sensitiveData" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="sensitiveData" name="sensitiveData" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="sensitiveData" name="sensitiveData" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

  <div class="form-control w-full">
    <label class="text-neutral-900" for="cashControl">¿Tiene acceso al control de caja?</label>

    <div class="flex flex-row gap-2 w-full">
      <label class="flex flex-row items-center">
        <input formControlName="cashControl" id="cashControl" name="cashControl" style="width: 1.5rem" type="radio" value="yes">
        <span>Si</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="cashControl" name="cashControl" style="width: 1.5rem" type="radio" value="no">
        <span>No</span>
      </label>
      <label class="flex flex-row items-center">
        <input formControlName="cashControl" name="cashControl" style="width: 1.5rem" type="radio" value="partial">
        <span>Parcial</span>
      </label>
    </div>
  </div>

  @if (showDocumentationSection) {
    <div class="flex flex-col gap-2 w-full">
      <div class="flex flex-row items-center justify-between border-b-1 pb-2 gap-3">
        <span>Documentación</span>
        <input #documentsInput (change)="handleDocumentsSelected($event)" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" class="hidden" multiple type="file">
        <button (click)="openDocumentsPicker()" [disabled]="isSubmitting" class="btn btn-neutral-text !px-1 !py-1" type="button">
          <img alt="Adjuntar documentos" class="filter-neutral-800 h-4" src="/assets/icons/feather/paperclip.svg">
        </button>
      </div>

      <div class="flex flex-col gap-2">
        @for (file of pendingAttachments; track file.name + '-' + file.size + '-' + $index) {
          <core-file-widget
            [fileName]="file.name"
            [fileSize]="formatFileSize(file.size)"
            [showDownload]="false"
            (remove)="removePendingAttachment.emit($index)"/>
        }

        @for (file of existingAttachments; track file.id) {
          <core-file-widget
            [fileName]="file.fileName"
            [fileSize]="formatFileSize(file.fileSize)"
            [showRemove]="showExistingAttachmentActions"
            (download)="downloadExistingAttachment.emit(file)"
            (remove)="removeExistingAttachment.emit(file)"/>
        }

        @if (!pendingAttachments.length && !existingAttachments.length) {
          <span class="cd-text-b3 text-neutral-500">Sin documentos adjuntos.</span>
        }
      </div>
    </div>
  }
</div>
